const appSettings = {
  // todo(oscar): group into an appsettings group
  // note(oscar): these are initialized by actions.setAppSettings()
  HeaderBannersAndModals: {
    promotions: []
  },
  HeaderSupportConfig: {},
};

const shouldFireHeaderEventablePageLoadEventStatus = {
  isLoading: false,
  isError: false,
  shouldFireHeaderEventablePageLoadEvent: false
};

// note(oscar): #1 convert to multiple reducers
export default {
  ...appSettings,
  shouldFireHeaderEventablePageLoadEventStatus,
  // note(oscar): probably related to discounts, maybe can exist in same reducer?
  enabledPromotions: [],
  tradeRequestInProgress: false,
  isTradeRequestCompleted: false,
  useModalUrlForAccountLinks: false,
  isInDotCom: false
};
